module.exports = __webpack_public_path__ + "img/question.2fb360e6.png";